import { convertHashToChoiceArray } from './convertHashToChoiceArray'

export function activityStillOccurring() {
  const choices = require('./json/activity_still_occurring.json')
  return convertHashToChoiceArray(choices)
}

export function communicationContact() {
  const choices = require('./json/communication_contact.json')
  return convertHashToChoiceArray(choices)
}

export function complaintType() {
  const choices = require('./json/complaint_type.json')
  return convertHashToChoiceArray(choices)
}

export function disclosurePermission() {
  const choices = require('./json/disclosure_permission.json')
  return convertHashToChoiceArray(choices)
}

export function disclosureType() {
  const choices = require('./json/disclosure_type.json')
  return convertHashToChoiceArray(choices)
}

export function fraudWasteAbuseAllegation() {
  const choices = require('./json/FWA_allegation.json')
  return convertHashToChoiceArray(choices)
}

export function grantContractFraudAllegation() {
  const choices = require('./json/GCF_allegation.json')
  return convertHashToChoiceArray(choices)
}

export function healthcareAllegation() {
  const choices = require('./json/HCF_allegation.json')
  return convertHashToChoiceArray(choices)
}

export function healthcareProgram() {
  const choices = require('./json/HCF_hhs_program.json')
  return convertHashToChoiceArray(choices)
}

export function hhsEmployeeType() {
  const choices = require('./json/hhs_employee_type.json')
  return convertHashToChoiceArray(choices)
}

export function IHSDateOccurred() {
  const choices = require('./json/IHS_date_occurred.json')
  return convertHashToChoiceArray(choices)
}

export function IHSPreviousContacts() {
  const choices = require('./json/IHS_previous_contacts.json')
  return convertHashToChoiceArray(choices)
}

export function familyRelationship() {
  const choices = require('./json/familyRelationship.json')
  return convertHashToChoiceArray(choices)
}

export function relationshipToSubject() {
  const generalChoices = require('./json/relationshipToSubject.json')
  const familyChoices = require('./json/familyRelationship.json')
  return convertHashToChoiceArray({ ...generalChoices, ...familyChoices })
}

export function sex() {
  const choices = require('./json/sex.json')
  return convertHashToChoiceArray(choices)
}

export function suffixes() {
  const choices = require('./json/suffixes.json')
  return convertHashToChoiceArray(choices)
}

export function usaStates() {
  const choices = require('./json/usa_states.json')
  return convertHashToChoiceArray(choices)
}

export function whistleblowerRetaliationEmployer() {
  const choices = require('./json/WBR_employer.json')
  return convertHashToChoiceArray(choices)
}

export function whistleblowerRetaliationProtectedCommunicationContact() {
  const choices = require('./json/WBR_protected_communication_contact.json')
  return convertHashToChoiceArray(choices)
}

export function whistleblowerRetaliationAction() {
  const choices = require('./json/WBR_retaliation_action.json')
  return convertHashToChoiceArray(choices)
}

export function whistleblowerRetaliationReason() {
  const choices = require('./json/WBR_retaliation_reason.json')
  return convertHashToChoiceArray(choices)
}

export function businessCategories(){
  const choices = require('hotline_complaint_choices').business_categories
  return convertHashToChoiceArray(choices)
}

export function individualCategories(){
  const choices = require('hotline_complaint_choices').individual_categories
  return convertHashToChoiceArray(choices)
}